import React, { useState, useEffect, useContext } from 'react';
import { AuthContext } from '../../contexts/AuthContext';

const AuthTimerTester = () => {
  const [timeRemaining, setTimeRemaining] = useState(30 * 60); // 30 minutes in seconds
  const [isRunning, setIsRunning] = useState(false);
  const [showWarning, setShowWarning] = useState(false);
  const { logout, refreshToken } = useContext(AuthContext);

  useEffect(() => {
    let interval;
    if (isRunning && timeRemaining > 0) {
      interval = setInterval(() => {
        setTimeRemaining((prevTime) => {
          if (prevTime === 5 * 60) { // 5 minutes remaining
            setShowWarning(true);
          }
          return prevTime - 1;
        });
      }, 10); // Update every 10ms to simulate faster time
    } else if (timeRemaining === 0) {
      handleSessionExpired();
    }
    return () => clearInterval(interval);
  }, [isRunning, timeRemaining]);

  const handleStart = () => {
    setIsRunning(true);
  };

  const handlePause = () => {
    setIsRunning(false);
  };

  const handleReset = () => {
    setIsRunning(false);
    setTimeRemaining(30 * 60);
    setShowWarning(false);
  };

  const handleExtendSession = () => {
    refreshToken();
    setTimeRemaining(30 * 60);
    setShowWarning(false);
  };

  const handleSessionExpired = () => {
    setIsRunning(false);
    logout();
  };

  const formatTime = (seconds) => {
    const minutes = Math.floor(seconds / 60);
    const remainingSeconds = seconds % 60;
    return `${minutes}:${remainingSeconds < 10 ? '0' : ''}${remainingSeconds}`;
  };

  return (
    <div className="auth-timer-tester space-y-4">
      <h2 className="text-lg font-semibold text-gray-900 dark:text-gray-100">Auth Timer Tester</h2>
      <div className="timer-display rounded-xl border border-gray-200 bg-white p-4 text-sm text-gray-600 dark:border-gray-700 dark:bg-gray-800 dark:text-gray-400">Time Remaining: <span className="ml-1 text-2xl font-extrabold tabular-nums text-gray-900 dark:text-gray-100">{formatTime(timeRemaining)}</span></div>
      <div className="controls flex flex-wrap gap-2">
        <button onClick={handleStart} disabled={isRunning} className="btn btn-primary">Start</button>
        <button onClick={handlePause} disabled={!isRunning} className="btn btn-secondary">Pause</button>
        <button onClick={handleReset} className="btn btn-secondary">Reset</button>
        <button onClick={() => setTimeRemaining(5 * 60)} className="btn btn-secondary">Set to 5 minutes</button>
      </div>
      {showWarning && (
        <div className="warning-dialog flex flex-wrap items-center justify-between gap-3 rounded-lg border border-warning-500/30 bg-warning-50 px-4 py-3 text-sm text-warning-800 dark:bg-warning-500/10 dark:text-warning-400">
          <p>Your session will expire in 5 minutes. Do you want to extend it?</p>
          <button onClick={handleExtendSession} className="btn btn-primary btn-sm">Extend Session</button>
        </div>
      )}
    </div>
  );
};

export default AuthTimerTester;